import { mapMySubscriptionProjects, MySubscriptionProject } from "./MySubscriptionProject";

export interface SubscriptionPlan {
    id?: number;
    plan_name?: string;
    monthly?: number;
    is_free?: 1 | 0;
    ProjectList?: MySubscriptionProject[];
}

// to single object maping
export const mapSubscriptionPlan = (data:any): SubscriptionPlan => {
    if(!data){
        throw new Error('Invalid Data')
    }
    const  res: SubscriptionPlan ={
        id: data.id,
        plan_name: data.plan_name,
        monthly: data.monthly,
        is_free: data.is_free,
        ProjectList:mapMySubscriptionProjects(data.ProjectList),
       
    }
    return res;
}

// maping list objects
export const mapSubscriptionPlans = (data:any[]): SubscriptionPlan[] => {
     if (!Array.isArray(data)) {
       throw new Error('Invalid Data');
     }
     return data.map(mapSubscriptionPlan);
}